import { render } from "./MyUnusableTicketView.vue?vue&type=template&id=16039d3e&ts=true"
import script from "./MyUnusableTicketView.vue?vue&type=script&lang=ts"
export * from "./MyUnusableTicketView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__